import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { query, collection, orderBy, limit, getDocs } from 'firebase/firestore';
import Table from '../people-finder-components/Table';
import Searchbar from '../people-finder-components/Searchbar';
import loading from '../../img/loading.gif';
import OutOfCreditsModal from '../OutOfCreditsModal';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth, db } from '../../firebase-config';

const PeopleFinder = (props) => {
  const [user] = useAuthState(auth);
  const [isLoading, setIsLoading] = useState(false);
  const [jobTitle, setJobTitle] = useState('');
  const [location, setLocation] = useState('');
  const [people, setPeople] = useState([]);
  const [isModalDisplayed, setIsModalDisplayed] = useState(false);
  const [latestSearchId, setLatestSearchId]     = useState(null);

  useEffect(() => {
    isModalDisplayed && (document.body.style.overflow = 'hidden');
    !isModalDisplayed && (document.body.style.overflow = 'unset');
  }, [isModalDisplayed]);

  useEffect(() => {
    const storedPeople = JSON.parse(localStorage.getItem('people'));
    const storedId = localStorage.getItem('peopleLatestId');
    if (storedPeople) {
      setPeople(storedPeople);
      setLatestSearchId(storedId);
    }
  }, []);

  useEffect(() => {
    if (!user || latestSearchId) return;
    (async () => {
      const q = query(
        collection(db, 'searches', user.uid, 'peopleSearches'),
        orderBy('createdAt', 'desc'),
        limit(1)
      );
      const snap = await getDocs(q);
      if (!snap.empty) setLatestSearchId(snap.docs[0].id);
    })();
  }, [user, latestSearchId]);

  const closeButtonClick = () => {
    setIsModalDisplayed(false);
  };

  const fetchPeople = async (jobTitle, location) => {
    if (!user) return;

    const response = await axios.get(`http://localhost:4242/v1/linkedin-scraper/${jobTitle}/${location}`, {
      params: { userId: user.uid }
    }).catch(err => console.error(err));

    if (response?.data?.success) {
      console.log('Got Data!!!');
      setPeople(response.data.rows);
      localStorage.setItem('people', JSON.stringify(response.data.rows));
      props.setCredits(prevCredits => (prevCredits - 1));
      const q    = query(
        collection(db, 'searches', user.uid, 'peopleSearches'),
        orderBy('createdAt', 'desc'),
        limit(1)
      );
      const snap = await getDocs(q);
      if (!snap.empty) {
        setLatestSearchId(snap.docs[0].id);
        localStorage.setItem('peopleLatestId', snap.docs[0].id);
      } else {
        localStorage.removeItem('peopleLatestId');
      }
    } else {
      alert(response?.data?.message || 'Search failed');
    }
    setIsLoading(false);
    setJobTitle('');
    setLocation('');
  };

  const handleFetchPeople = () => {
    if (props.credits <= 0) {
      setIsModalDisplayed(true);
      return;
    }
    if (jobTitle.length > 1 && location.length > 1) {
      setIsLoading(true);
      fetchPeople(jobTitle, location);
    }
  };

  const handleSetJobTitle = (value) => {
    setJobTitle(value);
  };

  const handleSetLocation = (value) => {
    setLocation(value);
  };

  return (
    <>
      <div className='people-finder'>
        <h1 className='app-title'>People Finder</h1>
        <Searchbar
          handleFetchPeople={handleFetchPeople}
          handleSetJobTitle={handleSetJobTitle}
          handleSetLocation={handleSetLocation}
          jobTitle={jobTitle}
          location={location}
        />
        {isLoading && <img className='loading-gif' src={loading} />}
        {!isLoading && <Table
          people={people}
          latestSearchId={latestSearchId}
          accountType={props.accountType}
        />}
      </div>
      {isModalDisplayed && <OutOfCreditsModal closeButtonClick={closeButtonClick} accountType={props.accountType} />}
    </>
  );
};

export default PeopleFinder;
